
import React from 'react';
import { useTable, usePagination, useGlobalFilter, useAsyncDebounce } from 'react-table'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTimes,
  faban,
} from "@fortawesome/free-solid-svg-icons";
import { apiServices } from '../../services/apiServices';

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  });

  return (
    <span>
      Search:{" "}
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} Cases...`}
        style={{
          fontSize: "1.1rem",
          border: "0",
        }}

      />
    </span>
  );
}

const Table = (props) => {
  // console.log(props)
    const [disabledRows, setDisabledRows] = React.useState([]);

  const data = React.useMemo(
    () => props.userData,
    []
  )
  const getUser = (user) => {
    console.log(user)
    // return
    apiServices.getAPI('organisationUnits/'+ user.id).then(res => {
      // console.log(res)
      props.edituser(res.data)
    })
  }
  const disableUser = (user) => {
      setDisabledRows((prev) => [...prev, user.id]);
    console.log("user",user)
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Facility Name',
        accessor: 'name',
      },
      {
        Header: 'Facility Address',
        accessor: 'address',
      },
      {
        Header: 'Phone number',
        accessor: 'phoneNumber',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
      {
        Header: 'Edit',
        Cell: props => <span className="btn btn-sm btn-blue"
          onClick={(e) => {
          getUser(props?.row?.original)
          }}><FontAwesomeIcon icon={faEdit} /></span>,
        accessor: 'Edit',
      },
      // {
      //   Header: 'Disable',
      //   Cell: props => <span className="btn btn-sm btn-blue"
      //     onClick={(e) => {
      //     disableUser(props?.row?.original)
      //     }}><i class="fa fa-ban" aria-hidden="true"></i></span>,
      //   accessor: 'Disable',
      // }
    ],
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,

    preGlobalFilteredRows,
    setGlobalFilter,

    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable({
    columns,
    data,
    initialState: { pageIndex: 0 },
  },
    useGlobalFilter,
    usePagination)
  return (
    <>
      <div className="pagination">
        <div className="alertfiltercontainer" style={{display:'none'}}>
        </div>
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={state.globalFilter}
          setGlobalFilter={setGlobalFilter}
          style={{ marginRight: "10px" }}
        />
        <button
          style={{ marginLeft: "10px" }}
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        >
          {"<<"}
        </button>{" "}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>{" "}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>{" "}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>{" "}
        <span>
          Page {" "}
          {/* <strong> */}
          {pageIndex + 1} of {pageOptions.length}
          {/* </strong>{" "} */}
        </span>
        <span>
          | Go to page:{" "}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "100px" }}
          />
        </span>{" "}
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 50, 100].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
      <table {...getTableProps()} className='linelistTable table-bordered mt-30px' style={{ width: "100%" }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps()}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
             const isDisabled = disabledRows.includes(row.original.id);
            return (
              <tr {...row.getRowProps()}
              style={{
                opacity: isDisabled ? 0.5 : 1,
                pointerEvents: isDisabled ? "none" : "auto",
              }}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  )
}
export default Table